module.exports = __webpack_public_path__ + "static/media/LoginMicrosite2.75aa5691.svg";